<template>
    <keep-alive>
         <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal_size sm_size">
                    <a href="JavaScript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                    <dl class="modal_content">
                        <dt class="ellipsis">
                            <i>{{$t('TITLE.POPUP.SELECT.ROLE')}}</i>
                        </dt>
                        <dd>
                            <!-- Grid -->
                            <div class="grid_wrap mt10">
                                <table class="scroll_table">
                                    <colgroup>
                                        <col width="15%">
                                        <col width="35%">
                                        <col width="*">
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th class="tC" width="15%">{{$t('FIELD.GLOVAL.CHECK')}}</th>
                                            <th class="tC" width="35%">{{$t('FIELD.ROLE.CODE')}}</th>
                                            <th class="tC" width="*">{{$t('FIELD.ROLE.NAME')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text_center">
                                        <tr v-for="auth in authRoles" :key="auth.AUTHCORPID">
                                            <td class="tC" width="15%">
                                                <label class="radiobox-wrap">
                                                    <input type="radio" name="selAuth" v-model="auth.selected" @change="selectRowChk(auth)" />
                                                    <i class="radio-icon"></i>
                                                </label>
                                            </td>
                                            <td width="35%">{{auth.AUTHID}}</td>
                                            <td width="*">{{auth.AUTHNM}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- detail_Authorization-->
                            <table class="create_table mt20">
                                <colgroup>
                                    <col width="35%" />
                                    <col width="*" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>{{$t('FIELD.AUTHREQ.AUTH')}}</th>
                                        <td>
                                            <label class="radiobox-wrap ">
                                                <input type="radio" name="creation" v-model="creationYn" value="N" checked="" />
                                                <i class="radio-icon"></i>
                                                <em>{{$t('FIELD.GLOBAL.ONLY.VIEW')}}</em>
                                            </label>
                                            <label class="radiobox-wrap">
                                                <input type="radio" name="creation" v-model="creationYn" value="Y" />
                                                <i class="radio-icon"></i>
                                                <em>{{$t('FIELD.GLOBAL.CREATION')}}</em>
                                            </label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="btn_modal_wrap topLine" style="padding:10px 1px 1px 1px; margin:5px 0px 1px 0px;">
                                <div class="btn_right">
                                    <a href="JavaScript:" class="btn_white" title @click="$emit('close')">{{$t('BUTTON.GLOBAL.CANCEL')}}</a>
                                    <a href="JavaScript:" class="btn_blue" title @click="authSave()">{{$t('BUTTON.GLOBAL.SELECT')}}</a>
                                </div>
                            </div>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    </keep-alive>
</template>
<script>
import Vue from 'vue';
import qs from 'query-string';
import axios from 'axios';
import { SDLUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';

// Toast Grid Custom Renderer
export default {
    name: 'selectRolePopup',
    components: {
    },
    computed: {
    },
    props: {
        'pCorpNo': { type: String, default: '' },
        rtnRoleFunc: { type: Function }
    },
    data() {
        return {
            creationYn: 'N',
            selectItem: {},
            authRoles: [],
            selectList: [],
            options: {
                scrollY: false,
                scrollX: false,
                minBodyHeight: 80,
                bodyHeight: 318,
                // rowHeaders: ['checkbox'],
            }
        };
    },
    methods: {
        async onSearch() {
            const param = {corpNo: this.pCorpNo};
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(`${SDLUtil.API_URL}/basis/common/auth/roleAuthPopupTobe.skp`, 
                    qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    console.log('pop.resp.data ==> ', resp.data);
                    this.authRoles = resp.data.rowData;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        selectRowChk(item) {
            this.selectItem = item;
        },
        authSave() {
            this.selectItem.CREATIONYN = this.creationYn;
            if (!this.selectItem.AUTHCORPID) {
                SDLUtil.alert('MESSAGE.GROBAL.NOSELECT');
                return;
            } else {
                this.rtnRoleFunc(this.selectItem);
                this.$emit('close');
            }

        }
    },
    mounted() {
        console.log('pCOrpNo ===> ', this.pCorpNo);
        this.onSearch();
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/system/menu/RoleAddPopup.vue